import {fromJS} from 'immutable';

import dieselReducer from '../../decorators/DieselReducer';

const DEFAULT_STATE = '';

function bootstrap({userAgent}) {
    return fromJS({
        userAgent
    });
}

dieselReducer('userAgent', (state = DEFAULT_STATE) => state, bootstrap);
